export class homeLabel_EN {

    home: {
        createNewQuotation: string;
        createUsedQuotation: string;
        searchQuotation: string;
        trackQuotation: string;
        pendingTasks: string;
        dealershipDetails: string;
        myProfile: string;
        recent: string;
        notifications: string;
        status: string;
        docUpload: string;
    }

    admin: {
        master: string;
        broadcast: string;
        userAdmin: string;
        dashboardAdmin:string;
        configuratorAdmin:string;
        imageUploads:string;
        taskManager:string;
        faq:string;
        dealerData:string;
    }

    constructor() {

        this.home = {
            createNewQuotation: "New Car Quotation",
            createUsedQuotation: "Used Car Quotation",
            searchQuotation: "Search Quotation",
            trackQuotation: "Track Application",
            pendingTasks: "Pending Tasks",
            dealershipDetails: "Dealership Details",
            myProfile: "My Profile",
            recent: "Recent Activities",
            notifications: "Notifications",
            status: "Reports",
            docUpload: "Documents Upload"
        }

        this.admin = {
            master: "Master Data Sync",
            broadcast: "Broadcast",
            userAdmin: "User",
            dashboardAdmin:"Dashboard",
            configuratorAdmin:"Configurator",
            imageUploads:"Image Uploads",
            taskManager:"Task Manager",
            faq:"FAQ",
            dealerData:"Dealer Data Upload"
        }
    }
}